// The site's entry. Everything global runs once here; everything a page owns
// runs through the page lifecycle (site/page.js), which mounts a page's
// features when its content arrives and stops them when it leaves.
//
// Global, once per document:
//   jQuery and the vendored plugins that attach to it; Modernizr; the cookie
//   banner; the header (site/init.js: sticky nav, menu, dropdowns, the form
//   API helpers); the fade, when this browser has it on.
//
// Per page, through mountPage / unmountPage:
//   carousels, players, forms, charts, marquees, FAQ accordions, motion
//   panels, the custom cursor, the UTM fields, and each page type's own
//   behaviour (docs/prd/2026-10-31-router-page-changes.md, R10 to R12).
import "../sass/style.scss"; // Vite compiles + emits the site CSS

import "./jquery-setup.js";
import "./plugins/modernizr-custom.js"; // vendored: custom Modernizr build
import "cookieconsent";

import "./site/init.js";
import "./site/cookies.js";
import { mountPage, unmountPage } from "./site/page.js";

// Page feel (docs/architecture/navigation-feel.md): whether this browser has it
// is decided in the head script (templates/_partials/page-feel.twig) from the
// site default and ?feel=. With it on, the router changes pages inside this
// document under the fade (docs/prd/2026-10-31-router-page-changes.md); it
// loads at once, so it is ready on the first click. Off: ordinary navigation,
// nothing more loads.
if (document.documentElement.dataset.feel === "fade") import("./site/router.js").then((m) => m.start());

// The site's one global: the lifecycle, for the QA harnesses (lifecycle-test.mjs,
// router-test.mjs) and anything that swaps the page's content in place; the
// router adds itself here when it starts.
window.growthcurve = { mountPage, unmountPage };

// The first page mounts once the document is parsed, as the page scripts
// always have (jQuery's plugins need the DOM).
document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector(".content-wrapper");
  if (root) mountPage(root);
});
